import React, { ReactNode, FC } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

type StyledLinkType = {
    children: ReactNode;
    activeChildren?: ReactNode;
    to?: string;
    activeClass?: boolean;
    activeUrl?: string;
    excludedActiveUrls?: string[];
    style?: React.CSSProperties;
    onClick?: () => void;
};

const normalizePath = (path: string): string => {
    const normalizedPath = path.endsWith('/') ? path.slice(0, -1) : path;
    return normalizedPath || '/';
};

export const isActivePath = (pathname: string, activeUrl: string, excludedActiveUrls: string[] = []): boolean => {
    const normalizedPathname = normalizePath(pathname);
    const normalizedActiveUrl = normalizePath(activeUrl);

    const matchesActiveUrl =
        normalizedPathname === normalizedActiveUrl || normalizedPathname.startsWith(`${normalizedActiveUrl}/`);

    if (!matchesActiveUrl) {
        return false;
    }

    return !excludedActiveUrls.some((excludedActiveUrl) => {
        const normalizedExcludedActiveUrl = normalizePath(excludedActiveUrl);
        return (
            normalizedPathname === normalizedExcludedActiveUrl ||
            normalizedPathname.startsWith(`${normalizedExcludedActiveUrl}/`)
        );
    });
};

const StyledLink: FC<StyledLinkType> = (props) => {
    const location = useLocation();

    if (!props.to) {
        return <>{props.children}</>;
    }

    const match = isActivePath(location.pathname, props.activeUrl || props.to, props.excludedActiveUrls);

    if (props.activeClass) {
        return (
            <NavLink
                to={props.to}
                className={'nav-link' + (match ? ' active' : '')}
                style={{ textDecoration: 'inherit', color: 'inherit', ...(props.style || {}) }}
                onClick={props.onClick}
            >
                {(match && props.activeChildren) || props.children}
            </NavLink>
        );
    }
    return (
        <Link
            to={props.to}
            style={{ textDecoration: 'inherit', color: 'inherit', ...(props.style || {}) }}
            onClick={props.onClick}
        >
            {props.children}
        </Link>
    );
};

export default StyledLink;
